<template>
  <div class="modal fade" id="prepaidFreightUpdateModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-truck me-2"/>
            Prepaid Freight Minimum Update
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
        </div>
        <div class="modal-body">
          <p>
            Please be advised that our <strong>Prepaid Freight Minimum</strong> will be changing effective <strong>July 1st</strong>.
          </p>
          <div class="alert alert-info">
            <div class="d-flex justify-content-between align-items-center">
              <span><strong>Previous Minimum:</strong></span>
              <span class="text-muted text-decoration-line-through">{{ previousMin }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <span><strong>New Minimum:</strong></span>
              <span class="text-success fw-bold">{{ newMin }}</span>
            </div>
          </div>
          <p class="text-muted small mb-0">
            Orders that meet or exceed the new minimum will continue to qualify for prepaid freight.
            Please contact your sales representative if you have any questions.
          </p>
        </div>
        <div class="modal-footer justify-content-between">
          <div class="form-check mb-0">
            <input
              class="form-check-input"
              type="checkbox"
              id="ppfDontShowAgain"
              v-model="dontShowAgain"/>
            <label class="form-check-label small" for="ppfDontShowAgain">
              Don't show again
            </label>
          </div>
          <button type="button" class="btn btn-primary" @click="dismiss">Got It</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {internalRoles} from '../../../shared/roles'
  import {freight} from '../../../shared/freight'

  const ELIGIBLE_COMPANIES = ['Lancaster US', 'Merit Supply']

  export default {
    data() {
      return { dontShowAgain: false }
    },
    watch: {
      initializing(newVal, oldVal) {
        if (oldVal === true && newVal === false && this.shouldShow) {
          this.$nextTick(() => {
            const el = document.getElementById('prepaidFreightUpdateModal')
            if (el) bootstrap.Modal.getOrCreateInstance(el).show()
          })
        }
      }
    },
    methods: {
      dismiss() {
        if (this.dontShowAgain) localStorage.setItem('ppfModalDismissed', 'true')
        const el = document.getElementById('prepaidFreightUpdateModal')
        if (el) bootstrap.Modal.getOrCreateInstance(el).hide()
      }
    },
    computed: {
      initializing() { return this.$store.getters.initializing },
      sessionCompany() { return this.$store.getters.sessionCompany },
      user() { return this.$store.getters.user },
      branchId() { return this.$store.getters.getEntity?.activeShipTo?.entity?.branch_id },
      previousMin() { return this.branchId === '14' ? '$850' : '$1,000' },
      activeShipTo() { return this.$store.getters.getEntity?.activeShipTo },
      newMin() {
        if(!this.activeShipTo) return '-'
        const f = freight()
        return f?.amount ? `$${f.amount.toLocaleString()}` : '-'
      },
      shouldShow() {
        if (!ELIGIBLE_COMPANIES.includes(this.sessionCompany)) return false
        if (internalRoles.includes(this.user?.role)) return false
        if (new Date() >= new Date('2026-07-20')) return false
        return localStorage.getItem('ppfModalDismissed') !== 'true'
      }
    }
  }
</script>
